import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../themeContext';

// Components 

import { Box } from '@mui/material';
import Container from '../components/hackerLogin/Container';
import Notification from '../components/general/notification/Notification';
import Page from '../components/general/containers/Page';

const HackerLogin: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { isLightMode, toggleTheme } = useTheme();

  // -- 

  useEffect(() => { 

    if (isLightMode) {

      toggleTheme(); 

    }; 

  },[isLightMode]); 

  // -- 

  return (

    <Page
      extraStyle={{ 
        backgroundColor: 'rgb(254,253,253)'
      }}
    >        

      <Container /> 

    </Page>
  );
};

export default HackerLogin;